
import React, { useEffect, useRef } from "react";

export const DrawChart = ({
    width = 800,
    height = 600,
    symbol = 'AAPL',
    watchlist = ["AAPL","AMZN","FB","GOOG","MSFT"],
    interval = 'D',
    darkMode = true,
    style = '1'
}) => {

    const containerRef = useRef(null);

    useEffect(() => {
        // Ensure the container is ready and the TradingView script is loaded.
        // The script is loaded in the main index.html.
        if (!containerRef.current || !window.TradingView) {
            return;
        }

        // To prevent re-creating the widget on every render, we clear the container
        // and instantiate a new widget. This is the recommended approach for this library.
        containerRef.current.innerHTML = '';

        const widget = new window.TradingView.widget({
            width: width,
            height: height,
            symbol: symbol,
            interval: interval,
            timezone: "Etc/UTC",
            theme: darkMode ? 'dark' : 'light',
            style: style,
            locale: "en",
            toolbar_bg: "#f1f3f6",
            enable_publishing: true,
            allow_symbol_change: true,
            hide_top_toolbar: false,
            watchlist: watchlist,
            container_id: containerRef.current.id,
        });

    }, [width, height, symbol, watchlist, interval, darkMode, style]); // Re-run effect if any of these props change

    return (
        <div id="watchlist" ref={containerRef} style={{ width, height }} />
    )
}
